import { useTranslation } from 'react-i18next';

// @ts-ignore
const Translator = ({ path }): any => {
  // eslint-disable-next-line id-length
  const { t } = useTranslation();
  return t(path);
};

export default Translator;
